angular.module('zc')
  .component('zcIwReport', {
    templateUrl: '/templates/projects.iw/iw_report.html',
    bindings: {
      project: '<'
    },
    controller: zcIwReportController
  });

zcIwReportController.$inject = ['$scope', '$translate', '$q', 'Page', 'SearchFilter', 'InterestWidgetStats', 'lib'];
function zcIwReportController($scope, $translate, $q, Page, SearchFilter, InterestWidgetStats, lib) {
  const vm = this;

  const RELEASED_AT = moment('2017/08/01', 'YYYY/MM/DD').toDate();

  Page.setBodyClass('');
  $translate('projectsIw.report.deliveryStatus').then(function(translation) {
    Page.setTitle(translation);
  });

  vm.filters = SearchFilter.resolveFromLocation({
    start_at: moment().startOf('month'),
    end_at: moment().endOf('day')
  });

  vm.showBetaAlert = false;
  vm.updateFilters = updateFilters;
  vm.resetFilters = resetFilters;

  vm.$onInit = () => {
    vm.updateFilters();
  };

  function updateFilters() {
    vm.showBetaAlert = moment(vm.filters.start_at).isBefore(RELEASED_AT);
    let device = ((vm.filters.device_value) ? vm.filters.device_value.name : null);
    if(device === 'pc') {
      device = { $in: ['pc', 'tablet'] };
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_pc;
    } else if(device === 'sp') {
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_sp;
    } else {
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_pc + vm.project.iw_fixed_monthly_invoice_amount_for_sp;
    }
    _.merge(vm.filters, {
      device: device,
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    });
    SearchFilter.set(vm.filters);
    $scope.$broadcast('filtersUpdated');
    updateData();
  }

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        if(stats.length) {
          vm.current_billing = getCurrentBilling();
          vm.costEffectiveness = (vm.current_billing !== 0) ? vm.total.iw_click_item.conversion_price / vm.current_billing * 100 : 0;
          vm.costRate = (vm.total.iw_click_item.conversion_price !== 0) ? vm.current_billing / vm.total.iw_click_item.conversion_price * 100 : 0;
        } else {
          vm.current_billing = vm.costEffectiveness = vm.costRate = 0;
        }
      });
  }

  function resetFilters() {
    $scope.$broadcast('filtersReset');
  }

  function getCurrentBilling() {
    const totalBillingFrom = moment(vm.filters.start_at).startOf('month');
    const totalBillingTo = moment(vm.filters.end_at).add(1, 'month').startOf('month');
    const totalBillingMonths = totalBillingTo.diff(totalBillingFrom, 'months');
    const totalBillingDays = totalBillingTo.diff(totalBillingFrom, 'days');
    const currentBillingFrom = moment(vm.filters.start_at).startOf('day');
    const currentBillingTo = moment(vm.filters.end_at).add(1, 'day').startOf('day');
    const currentBillingDays = currentBillingTo.diff(currentBillingFrom, 'days');
    return vm.iwFixedMonthlyInvoiceAmount * totalBillingMonths * (currentBillingDays / totalBillingDays);
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_report.js